import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';

/**
 *  Naming note: these names are obsolete. When moving to Pigment design-tokens, the previous medium size has been removed in favor of the large one, which we now call medium. XS doesn't exist anymore.
 */
export default {
  /**
   * Pigment terminology: onlySmall
   */
  onlySmallAndXSmall: `(max-width: ${designTokens.breakpoints.md.value - 1}px)`,
  /**
   * Pigment terminology: onlySmall
   */
  onlyMediumSmallAndXSmall: `(max-width: ${designTokens.breakpoints.md.value - 1}px)`,
  /**
   * Pigment terminology: onlyMedium
   */
  onlyMedium: `(min-width: ${designTokens.breakpoints.md.value}px) and (max-width: ${designTokens.breakpoints.lg.value}px)`,
  /**
   * Pigment terminology: onlyMedium
   */
  onlyLarge: `(min-width: ${designTokens.breakpoints.md.value}px) and (max-width: ${designTokens.breakpoints.lg.value}px)`,
  /**
   * Pigment terminology: onlySmall
   */
  mediumAndBelow: `(max-width: ${designTokens.breakpoints.md.value - 1}px)`,
  /**
   * Pigment terminology: mediumAndAbove
   */
  mediumAndAbove: `(min-width: ${designTokens.breakpoints.md.value}px)`,
  /**
   * Pigment terminology: mediumAndAbove
   */
  largeAndAbove: `(min-width: ${designTokens.breakpoints.md.value}px)`,
  /**
   * Pigment terminology: xlAndAbove
   */
  xxLargeAndAbove: `(min-width: ${designTokens.breakpoints.xl.value}px)`
};

export function breakpoint(size) {
  // TODO: Remove this once we have a polyfill for matchMedia in place for Jjesest
  if (window.matchMedia === undefined) return false;
  return window.matchMedia(size).matches;
}
